import React, { useEffect, useState } from "react";
import "../SellerConfirmedOrdersDetails/SellerConfirmedOrdersDetails.css";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import SellerServicesUrl from "../../SellerServicesUrl";
import emptyorders from "../../assets/empty-cart.png";
import { BaseUrl } from "../../App";

export default function SellerConfirmedOrdersDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const orderId = id;

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);

  const orderInfo = order?.order;
  const userInfo = order?.user;
  const items = order?.items || [];
  const currentStatus = orderInfo?.status;

  /* ================= CHANGE STATUS ================= */
  const handleStatusChange = async () => {
    if (!orderInfo) return;

    try {
      // await axios.get(
      //   `${BaseUrl}saller/order-status/${orderInfo.order_id}`,
      //   {
      //     status:
      //       currentStatus === "processing"
      //         ? "shipping"
      //         : "completed",
      //   },
      //   {
      //     headers: {
      //       Authorization: `Bearer ${localStorage.getItem("seller_token")}`,
      //       Accept: "application/json",
      //     },
      //   }
      // );
await axios.post(
  `${BaseUrl}admin/update-status-order/${orderInfo.order_id}`,
  {
    status:
      currentStatus === "processing"
        ? "shipping"
        : "completed",
  },
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      Accept: "application/json",
    },
  }
);
      setShowConfirm(false);

      // رجوع لصفحة الطلبات عشان يحصل refresh للقائمة
      navigate("/seller/sellerconfirmedorders");

    } catch (err) {
      console.log(err);
    }
  };

  /* ================= FETCH ================= */
  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          `${BaseUrl}${SellerServicesUrl.OrderDetails}/${orderId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "token"
              )}`,
              Accept: "application/json",
            },
          }
        );

        setOrder(res.data?.data || null);
      } catch (err) {
        console.log(err);
        setOrder(null);
      } finally {
        setLoading(false);
      }
    };

    if (orderId) fetchOrderDetails();
  }, [orderId]);

  if (loading) {
    return (
      <div className="orders-loader text-center py-5 mt-5" style={{minHeight:"100vh",marginTop:"100px"}}>
        <div className="loader-circle mb-3 mt-5 "></div>
        <p className="fw-bold">جاري تحميل التفاصيل...</p>
      </div>
    );
  }

  if (!order || !orderInfo) {
    return (
      <div className="noorders text-center mt-5">
        <img src={emptyorders} alt="no-data" />
        <h4 className="mt-4">لا توجد بيانات لهذا الطلب</h4>
        <button
          className="order-btn mt-3"
          onClick={() => navigate("/seller/sellerconfirmedorders")}
        >
          الرجوع للطلبات
        </button>
      </div>
    );
  }

  return (
    <div
      className="container order-page pt-5"
      style={{ marginTop: "6%", marginBottom: "22%" }}
    >
      {/* USER */}
      <div className="card-box mb-4 user-card">
        <div className="avatar-circle mb-3 " style={{height:"70px",width:"70px"}}>
          <i className="fa-solid fa-user m-auto "></i>
        </div>
        <div>
          <h5 className="fw-bold">{userInfo?.name}</h5>
          <p className="small-text">{userInfo?.phone}</p>
          <p className="small-text">{userInfo?.email}</p>
          <p className="small-text">{userInfo?.country}</p>
        </div>
      </div>

      {/* PRODUCTS */}
      <div className="coproduct-details">
        <h6 className="fw-bold mb-3">تفاصيل المنتج</h6>

        {items.map((item) => (
          <div className="card-box mb-3" key={item.item_id}>
            <div className="product-wrapper-new position-relative w-100">
              
              {/* <div className="side-lock-codetails">
                <i className="fa fa-lock colockicon"></i>
              </div> */}
              {/* {!item.image && (
  <div className="side-lock-codetails">
    <i className="fa fa-lock colockicon"></i>
  </div>
)} */}
<div className="side-lock-codetails">
  {item.image ? (
    <img
      src={item.image}
      alt=""
      onError={(e) => {
    e.target.style.display = "none";
    e.target.parentNode.innerHTML =
      '<i class="fa fa-lock colockicon"></i>';
  }}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: "8px"
      }}
    />
  ) : (
    <i className="fa fa-lock colockicon"></i>
  )}
</div>

              <div className="coproduct-info">
                <h6 className="fw-bold mb-1">{item.item_name}</h6>

                <p className="small-text mb-2">
                  {item.description?.length > 150
                    ? item.description.slice(0, 150) + "..."
                    : item.description}
                </p>

                <div className="discount-price-row">
                  <div className="discount-row">
                    <span className="qty-badge">
                      x{item.quantity}
                    </span>
                    <span className="discount-text">
                      خصم {item.discount} %
                    </span>
                  </div>

                  <div className="price-text">
                    {item.total}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        <hr className="codetails-line" />

        {/* SUMMARY */}
        <div className="card-box summary-card mt-3 mb-5">
          <div className="cosummary-row">
            <span>العدد :</span>
            <span>{orderInfo.count_items}</span>
          </div>

          <div className="cosummary-row">
            <span>السعر :</span>
            <span>{orderInfo.total} ر.س</span>
          </div>

          <div className="cosummary-row">
            <span>مصاريف الشحن :</span>
            <span>{orderInfo.fees} ر.س</span>
          </div>

          <div className="cosummary-row">
            <span>طريقة الدفع :</span>
            <span>
              {orderInfo.payment_type === "visa"
                ? "فيزا"
                : orderInfo.payment_type}
            </span>
          </div>

          <div className="cosummary-row total-row">
            <span>الإجمالي</span>
            <span>{orderInfo.final_total} ر.س</span>
          </div>
        </div>

        {/* STATUS */}
        <div className="order-status-card">
          <div className="status-row">
            <span className="status-title">حالة الطلب</span>
            <span className="status-text">
              {currentStatus === "processing"
                ? "جاري المعالجة"
                : currentStatus === "shipping"
                ? "تم الشحن"
                : currentStatus === "completed"
                ? "تم التسليم"
                : currentStatus === "cancelled"
                ? "ملغي"
                : ""}
            </span>
          </div>
        </div>

        {/* ACTION BUTTON */}
        {(currentStatus === "processing" ||
          currentStatus === "shipping") && (
          <button
            className="shipment-btn"
            onClick={() => setShowConfirm(true)}
          >
            {currentStatus === "processing"
              ? "تم الشحن"
              : "تم التوصيل"}
          </button>
        )}

        {/* CONFIRM MODAL */}
        {showConfirm && (
          <div className="confirm-overlay">
            <div className="confirm-box">
              <h5 className="confirm-title">تأكيد</h5>

              <p className="confirm-text">
                هل أنت متأكد من تنفيذ هذه العملية؟
              </p>

              <div className="confirm-buttons">
                <button
                  className="confirm-btn"
                  onClick={handleStatusChange}
                >
                  نعم
                </button>

                <button
                  className="cancel-btn"
                  onClick={() => setShowConfirm(false)}
                >
                  لا
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}